export const addUrlParam = (path: string, key: string, value: string | number): string =>
  `${path}${(path.includes('?') && '&') || '?'}${key}=${value}`
